import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import WidgetHeader from '../Widget/WidgetHeader';
import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';

import { isLongText } from '../../components/Shared/commonFunctions';
import { ImageBanner, ButtonRow } from '../../components/Link/Components';
import LinkButton from '../../components/Link/LinkButton';
import ShareDrawer from '../../components/ShareDrawer';
import { Container } from '../../containers/DefaultStyles/Details';
import {
    DetailsContainer,
    Footer,
    Title,
    Description,
    Content,
    Details,
    Body
} from '../DefaultStyles/Shared';

import {
    setOverlayPartnerVisible,
    onGoToNextCard,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';
import { onCompleteLink } from './actions';

import { getActionCompletedTime } from '../../utils/actionTiming';
import { isPortrait } from '../../utils/size';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { ActionTypes } from '../../utils/enums';
import { copyFor } from '../../copy/copy';

const LinkDetails = props => (
    <Container
        desktopLinkImage={!!props.desktopImageId && props.isVisualLink && !isPortrait()}
    >
        <Overlay />
        <OverlayPublisher />
        <OverlayPartner transitionType="right-to-left" />
        <Body className="body-msn-override">
            <WidgetHeader />
            {props.isVisualLink && (
                <ImageBanner
                    desktopImageId={props.desktopImageId}
                    mobileImageId={props.mobileImageId}
                />
            )}
            <Content
                isContactAction={true}
                useLocalRepresentative={false}
                isSingleAction={true}
            >
                <Title
                    isLocalRepLoading={false}
                    isLongText={isLongText(props.cardTitle, 40)}
                    isExtraLongText={isLongText(props.cardTitle, 95)}
                    onClick={e => props.setOverlayPartnerVisible(true, e, false)}
                    dangerouslySetInnerHTML={{
                        __html: props.cardTitle
                    }}
                />
                <DetailsContainer>
                    <Details>
                        <Description
                            dangerouslySetInnerHTML={{ __html: props.linkText }}
                            onClick={e => props.setOverlayPartnerVisible(true, e, false)}
                        />
                    </Details>
                </DetailsContainer>
            </Content>
            <ButtonRow>
                <LinkButton
                    style={{ margin: 0 }}
                    label={props.buttonText}
                    onClick={() => {
                        window.open(props.linkUrl, '_blank');
                        props.setExitingCardProps('link', props, props.activeAction);

                        props.onCompleteLink(
                            props.apiRequestData,
                            props.actionCompletedTime(),
                            props.actionIdentifier,
                            props.isVisualLink
                        );
                        if (props.nextAction) {
                            props.onGoToNextCard(
                                props.nextAction.identifier,
                                props.nextCard.type,
                                props.nextAction.type,
                                props.nextAction.skipFrontCard ||
                                    props.nextAction.scrollableDesign,
                                false
                            );
                        }
                    }}
                />
            </ButtonRow>
            <Footer>
                <ShareDrawer
                    beforeBack={() => {
                        props.setExitingCardProps('link', props, props.activeAction);
                    }}
                    backgroundColor={'#fff'}
                />
            </Footer>
        </Body>
    </Container>
);

LinkDetails.propTypes = {
    actionCompletedTime: PropTypes.func.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    activeAction: PropTypes.object.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    buttonText: PropTypes.string.isRequired,
    cardTitle: PropTypes.string.isRequired,
    desktopImageId: PropTypes.string,
    isVisualLink: PropTypes.bool.isRequired,
    linkText: PropTypes.string.isRequired,
    linkUrl: PropTypes.string.isRequired,
    mobileImageId: PropTypes.string,
    nextAction: PropTypes.object,
    nextCard: PropTypes.object,
    onCompleteLink: PropTypes.func.isRequired,
    onGoToNextCard: PropTypes.func.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired
};

const specifyProtocol = url =>
    url
        ? url.indexOf('http://') === 0 || url.indexOf('https://') === 0
            ? url
            : 'http://' + url
        : '';

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'link',
            ['/link', '/link/start'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const currCard = state.widget.cards[state.widget.activeAction.order - 1];
        const activeAction = state.widget.activeAction;
        const nextAction = getNextAction(
            state.widget.actions,
            activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            actionCompletedTime: getActionCompletedTime(state, 'link'),
            actionIdentifier: activeAction.identifier,
            activeAction,
            apiRequestData: state.widget.apiRequestData,
            buttonText:
                activeAction.customButtonText ||
                copyFor('multiactionCard', 'button', 'link'),
            cardTitle:
                currCard.heading ||
                activeAction.customHeader ||
                copyFor('multiactionCard', 'title', 'link'),
            desktopImageId: activeAction.desktopImageId,
            isVisualLink: activeAction.isVisual,
            linkText: currCard.subHeading || activeAction.name,
            linkUrl: (window || {}).clickTAG || specifyProtocol(activeAction.url), // first choice is URL provided by ad servers
            mobileImageId: activeAction.mobileImageId,
            nextAction,
            nextCard: nextAction ? state.widget.cards[nextAction.order - 1] : null
        };
    },
    {
        onCompleteLink,
        onGoToNextCard,
        setExitingCardProps,
        setOverlayPartnerVisible
    },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.Link) return true;
            return next === prev;
        }
    }
)(LinkDetails);
